/* 🤖 this file was generated by script */
export const wsolidiconClockStopwatch = {
  name: 'clock_stopwatch',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10 1a1 1 0 0 0 0 2h1v1.05a9.5 9.5 0 1 0 2 0V3h1a1 1 0 1 0 0-2zm3 8.5a1 1 0 1 0-2 0v4a1 1 0 0 0 .49.86l2.5 1.5A1 1 0 0 0 15 14.14L13 12.94z" clip-rule="evenodd"/><path fill="currentColor" d="M18.12 3.38a1 1 0 0 1 1.42 0l1.5 1.5a1 1 0 0 1-1.42 1.42l-1.5-1.5a1 1 0 0 1 0-1.42M5.88 3.38a1 1 0 0 1 0 1.42l-1.5 1.5a1 1 0 1 1-1.42-1.42l1.5-1.5a1 1 0 0 1 1.42 0"/></svg>`,
  iconStyle: 'solid',
};
